// extracted by mini-css-extract-plugin
module.exports = {"paginationWrap":"_23kFP6fWpyGodHVAM31EHi","slide":"_1GKcRksqT45JV-ldJ6xfFy"};